const analyticsService = {
  trackFeature: (eventName, eventAction) => {
    try {
      s.tl(true, 'o', 'FeatureTracking : ' + eventName + ' : ' + eventAction);
    } catch (e) {} // eslint-disable-line no-empty
  },
};

export default analyticsService;
